module.exports = __webpack_public_path__ + "static/media/master.6cf3d7c4.svg";